import MemberActivity from './MemberActivity.component';

export default MemberActivity;
